<template>
  <div id="jobDetails">
    <div class="detail_container">
      <div class="detail_title_info">
        <div class="job_info_container">
          <div class="job_info">{{ list.positionName }}</div>
          <div class="salary_info">
            <span v-if="list.payRange">{{ list.payRange }}万</span
            ><span v-else>暂无</span>
          </div>
        </div>
        <div class="base_info">
          <div class="city">
            <img
              src="@/assets/hr/city_icon.png"
              alt=""
              class="base_info_icon"
            />
            <div>{{ list.workAddr }}</div>
          </div>
          <div class="year">
            <img
              src="@/assets/hr/year_icon.png"
              alt=""
              class="base_info_icon"
            />
            <div>{{ list.workExperience }}年</div>
          </div>
          <div class="education">
            <img
              src="@/assets/hr/education_icon.png"
              alt=""
              class="base_info_icon"
            />
            <div>{{ list.education }}</div>
          </div>
        </div>
      </div>
      <div class="detail_recruit_info">
        <div
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
          "
        >
          <div class="content_title_info">
            <div class="title_icon"></div>
            <div class="title_text">岗位信息</div>
          </div>
          <div class="title_right_info">
            <div
              v-if="expansionAndPutAwayFlag"
              @click="expansionAndPutAway(false)"
            >
              收起 <i class="el-icon-arrow-down"></i>
            </div>
            <div v-else @click="expansionAndPutAway(true)">
              展开 <i class="el-icon-arrow-up"></i>
            </div>
          </div>
        </div>
        <div
          class="detail_text_info"
          v-html="list.positionStatement"
          v-if="expansionAndPutAwayFlag"
        ></div>
      </div>
      <div class="detail_recruit_info">
        <div class="content_title_info">
          <div class="title_icon"></div>
          <div class="title_text">被推荐人信息</div>
        </div>
        <el-form ref="form" label-width="50px" label-position="left">
          <el-form-item label="姓名：">
            <div class="from_info">{{ list.name }}</div>
          </el-form-item>
          <el-form-item label="电话：">
            <div class="from_info">{{ list.tel }}</div>
          </el-form-item>
          <el-form-item label="邮箱：">
            <div class="from_info">{{ list.email }}</div>
          </el-form-item>
          <el-form-item label="简历：">
            <img src="@/assets/hr/resume_icon.png" alt="" class="resume_icon" />
            <template v-if="fileList.length > 0">
              <van-uploader
                v-for="(item, index) in fileList"
                :key="index"
                multiple
                :deletable="false"
                class="upload_resume"
                :readonly="true"
              >
                <div @click="toIframe(item)" style="margin-left: 20px;">{{ item.name }}</div>
                <div v-if="iframe">
                  <van-overlay :show="iframe" @click="iframe = false">
                    <div class="iframe">
                      <img :src="item.url" alt="" />
                    </div>
                  </van-overlay>
                </div>
              </van-uploader>
            </template>
            <div v-else>暂无简历</div>

            <!-- <van-icon v-if="fileName" name="close" @click="closeFile" /> -->
          </el-form-item>
        </el-form>
        <div class="correlation_info">
          <div v-if="list.operateNo || list.operateName">
            推荐人：{{ list.operateNo }}{{ list.operateName }}
          </div>
          <div v-if="list.relation">关系：{{ list.relation }}</div>
        </div>
      </div>
      <div class="detail_recruit_info">
        <div class="content_title_info">
          <div class="title_icon"></div>
          <div class="title_text">投递进度</div>
        </div>
        <el-steps
          direction="vertical"
          :active="active"
          finish-status="success"
          :space="38"
          v-for="(item, index) in list.items"
          :key="index"
        >
          <el-step :title="item.itemName">
            <slot slot="description">
              <p>{{ item.itemTime }}</p>
            </slot>
          </el-step>
        </el-steps>
      </div>
      <!-- <div class="btn_info">
        <van-button plain type="danger" class="out" @click="outClick">淘汰</van-button>
        <van-button plain type="primary" class="reexamine" @click="reexamineClick">复试</van-button>
        <van-button type="success" class="pass" @click="passClick">通过</van-button>
      </div> -->
    </div>
  </div>
</template>

<script>
import api from "@/apis/user";
// import { downloadExcel } from "@/utils/tools";
export default {
  data() {
    return {
      expansionAndPutAwayFlag: false,
      fileList: [
        // {
        //   url:'https://img01.yzcdn.cn/vant/leaf.jpg',
        //   file:new File([],'hahah.png')
        // }
      ],
      active: 0,
      recordUuid: "",
      list: {},
      iframe: false,
    };
  },
  mounted() {
    this.recordUuid = this.$route.query.recordUuid;
    this.getList();
  },
  methods: {
    //查看简历
    toIframe(item) {
      if (
        item.path.includes(".png") ||
        item.path.includes(".jpeg") ||
        item.path.includes(".gif") ||
        item.path.includes(".svg") ||
        item.path.includes(".bmp")
      ) {
        this.iframe = true;
      } else {
        // let arr = item.name.lastIndexOf(".");
        // // 获取文件不带点后缀
        // let ext = item.name.substr(arr + 1);
        // // 获取文件带点后缀
        // let str = item.name.substr(arr);
        // // 将后缀转为空字符串
        // let name = item.name.replace(str,'')
        // console.log(name,'111');
        // downloadExcel(item.url,name, ext);
        window.location.href = `https://qw.nvc-lighting.com.cn:8082/file/down/${item.fileId}`;
      }
    },
    //获取简历
    getList() {
      api
        .selectResumeSelfDetail({ recordUuid: this.recordUuid })
        .then((data) => {
          this.list = data.data;
          this.active = this.list.items.length;
          this.list.fileList.forEach((item) => {
            this.fileList.push({
              url: item.fileUrl,
              name: item.fileName,
              path: item.filePath,
            });
          });
        });
    },
    expansionAndPutAway(flag) {
      this.expansionAndPutAwayFlag = flag;
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  #jobDetails {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  #jobDetails {
    width: 276px * $zoom;
  }
}
#jobDetails {
  font-size: 16px * $zoom;
  position: relative;
  .detail_container {
    width: 100%;
    min-height: 100vh;
    // padding-bottom: 136px;
    background: #f7f9fa;
    .detail_title_info {
      padding: 36px 32px;
      background: #fff;
      .job_info_container {
        display: flex;
        justify-content: space-between;
        .job_info {
          font-size: 36px;
          font-weight: bold;
          color: #282b32;
        }
        .salary_info {
          font-size: 36px;
          font-weight: bold;
          color: #4ea27c;
        }
      }
      .base_info {
        overflow: hidden;
        margin-top: 20px;
        color: #969b9e;
        font-size: 28px;
        font-weight: bold;
        & > div {
          float: left;
          padding-right: 28px;
        }
        .city {
          display: flex;
          align-items: center;
          .base_info_icon {
            width: 26px;
            height: 32px;
            margin-right: 12px;
          }
        }
        .year {
          display: flex;
          align-items: center;
          .base_info_icon {
            width: 28px;
            height: 28px;
            margin-right: 12px;
          }
        }
        .education {
          display: flex;
          align-items: center;
          .base_info_icon {
            width: 36px;
            height: 30px;
            margin-right: 12px;
          }
        }
      }
      .arrive_time_info {
        margin-top: 40px;
        color: #666666;
        font-size: 28px;
      }
    }
    .detail_recruit_info {
      margin-top: 24px;
      padding: 32px;
      background: #fff;
      font-size: 30px;
      .title_right_info {
        color: #969b9e;
        font-size: 30px;
        cursor: pointer;
      }
      .content_title_info {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .title_icon {
          width: 8px;
          height: 32px;
          margin-right: 20px;
          background: #4ea27c;
          border-radius: 4px;
        }
        .title_text {
          font-size: 32px;
          font-weight: bold;
          color: #282b32;
        }
      }
      ::v-deep .el-form {
        margin-bottom: 40px;
        padding: 30px 0 40px;
        border-bottom: 2px solid #f1f1f1;
        font-size: 30px;
        .el-form-item {
          &:last-child {
            margin: 0;
          }
          .el-form-item__label {
            padding: 0;
            line-height: 42px;
            color: #666666;
          }
          .el-form-item__content {
            display: flex;
            position: relative;
            line-height: 42px;
            .from_info {
              color: #282b32;
            }
            .upload_resume {
              color: #4ea27c;
            }
            .van-icon-close {
              position: absolute;
              right: 0;
              top: 50%;
              transform: translateY(-50%);
              color: #4ea27c;
            }
            .resume_icon {
              width: 32px;
              height: 36px;
              margin-right: 20px;
            }
          }
        }
      }
      .correlation_info {
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #969b9e;
      }
      .detail_text_info {
        text-overflow: ellipsis;
        margin-top: 20px;
        color: #666666;
        font-size: 30px;
        line-height: 56px;
      }
    }
    .btn_info {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      padding: 32px;
      .van-button {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 124px;
        height: 52px;
        margin-left: 40px;
        background: #fff;
        border: 2px solid #e22121;
        border-radius: 8px;
      }
      .reexamine {
        border: 2px solid #5dd5c9;
        color: #5dd5c9;
      }
      .pass {
        background: #4ea27c;
        border: 2px solid #4ea27c;
        color: #fff;
      }
    }
  }
  ::v-deep .el-steps {
    padding-top: 30px;
    .el-step {
      .el-step__title.is-success,
      .el-step__title.is-process {
        color: #282b32;
        font-weight: 600;
        font-size: 30px;
      }
      .el-step__title.is-wait {
        font-weight: 500;
        color: #969b9e;
        font-size: 30px;
      }
      .el-step__description.is-success,
      .el-step__description.is-process {
        color: #666666;
        font-size: 28px;
      }
      .el-step__description.is-wait {
        font-size: 28px;
        color: #969b9e;
      }
      .el-step__head.is-success,
      .el-step__head.is-process {
        border-color: #4ea27c;
        color: #4ea27c;
      }
      .el-step__head.is-success {
        .el-step__icon.is-text {
          background: #4ea27c;
          .el-step__icon-inner.is-status {
            z-index: 9;
            color: #fff;
          }
        }
      }
    }
  }
  ::v-deep .van-overlay {
    z-index: 10 !important;
  }
}
.iframe {
  width: 80%;
  height: 90%;
  margin-left: 10%;
  margin-top: 10%;
  img {
    width: 100%;
    height: 100%;
  }
}
</style>
